module.exports = __webpack_public_path__ + "img/logo_texto_branco.cdb6cda2.png";